var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-gallery-vessel"},[_c('div',{staticClass:"page",on:{"click":_vm.addImage}},[_c('img',{attrs:{"src":_vm.illustratedBookIconUrl}}),_vm._v(" "),_c('small',[_vm._v("Please upload your images")])]),_vm._v(" "),_c('div',{staticClass:"page",on:{"click":_vm.addImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }